
(()=>{
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root=window.Shopify?.routes?.root||'/';
  const cartSection='valuraa-cart-drawer';
  let drawerReturnFocus=null;
  const setDrawerOpenState=(open)=>{
    const expanded=String(Boolean(open));
    document.body?.classList.toggle('vf-drawer-open',Boolean(open));
    document.querySelectorAll('.vf-cart-link').forEach((link)=>link.setAttribute('aria-expanded',expanded));
  };
  const captureDrawerReturnFocus=(drawer)=>{
    const active=document.activeElement;
    if(active instanceof HTMLElement&&active!==document.body&&!drawer?.contains(active))drawerReturnFocus=active;
  };
  const restoreDrawerFocus=()=>{
    const target=drawerReturnFocus?.isConnected?drawerReturnFocus:null;
    drawerReturnFocus=null;
    if(target)requestAnimationFrame(()=>target.focus?.({preventScroll:true}));
  };
  let cartQueue=Promise.resolve();

  const enqueue=(task)=>{
    cartQueue=cartQueue.then(task,task);
    return cartQueue;
  };

  const currentCurrency=()=>document.documentElement.dataset.currency||'USD';
  const triggerLabelNode=(trigger)=>trigger?.querySelector('[data-vf-trigger-label]')||null;
  const readTriggerLabel=(trigger)=>triggerLabelNode(trigger)?.textContent.trim()||trigger?.textContent.trim()||'';
  const writeTriggerLabel=(trigger,label)=>{
    if(!trigger)return;
    const node=triggerLabelNode(trigger);
    if(node)node.textContent=label;
    else trigger.textContent=label;
  };
  const money=(cents)=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:currentCurrency()}).format(cents/100);

  const buttonLabel=(button)=>button?.querySelector?.('[data-vf-trigger-label],[data-vf-button-label]')||button;
  const buttonText=(button)=>buttonLabel(button)?.textContent||'';
  const setButtonText=(button,textValue)=>{const node=buttonLabel(button);if(node)node.textContent=textValue||''};

  const cartCount=()=>{
    const node=document.querySelector('.vf-cart-link [data-vf-cart-count]');
    return Math.max(0,Number((node?.textContent||'').replace(/[^0-9]/g,''))||0);
  };

  const updateCartCount=(count)=>{
    document.querySelectorAll('.vf-cart-link [data-vf-cart-count]').forEach((node)=>{
      const value=Math.max(0,count);
      const badge=node.closest('.vfdock')||node.classList.contains('vfh2__bag-count');
      node.textContent=badge?String(value):'('+value+')';
    });
  };

  const optimisticCount=(delta)=>{
    updateCartCount(cartCount()+Math.max(0,delta));
    document.querySelectorAll('.vf-cart-link').forEach((link)=>{
      link.classList.remove('is-pulsing');
      requestAnimationFrame(()=>link.classList.add('is-pulsing'));
    });
  };

  const parseDrawer=(html)=>{
    if(!html)return null;
    return new DOMParser().parseFromString(html,'text/html').querySelector('[data-vf-drawer]');
  };

  const syncShippingProgress=(drawer)=>{
    if(!drawer)return;
    const total=Math.max(0,Number(drawer.dataset.vfCartTotal)||0);
    const qualifyingTotal=Math.max(0,Number(drawer.dataset.vfQualifyingTotal)||total);
    const rate=Math.max(.000001,Number(window.Shopify?.currency?.rate)||1);

    const shippingWrap=drawer.querySelector('[data-vf-shipping-progress]');
    const shippingThreshold=Math.max(0,Number(drawer.dataset.vfFreeShippingThreshold)||0);
    if(shippingWrap&&shippingThreshold>0){
      const threshold=Math.round(shippingThreshold*100*rate);
      const remaining=Math.max(0,threshold-total);
      const percent=Math.min(100,threshold?total/threshold*100:0);
      const statusNode=drawer.querySelector('[data-vf-shipping-status]');
      const bar=drawer.querySelector('[data-vf-shipping-bar]');
      if(bar)bar.style.width=percent+'%';
      if(statusNode){
        const template=remaining<=0?drawer.dataset.vfShippingUnlocked:drawer.dataset.vfShippingLocked;
        statusNode.textContent=(template||'').replace('[amount]',money(remaining));
      }
    }

    const giftWrap=drawer.querySelector('[data-vf-gift-progress]');
    const giftThreshold=Math.max(0,Number(drawer.dataset.vfGiftThreshold)||0);
    if(giftWrap&&giftThreshold>0){
      const threshold=Math.round(giftThreshold*100*rate);
      const remaining=Math.max(0,threshold-qualifyingTotal);
      const percent=Math.min(100,threshold?qualifyingTotal/threshold*100:0);
      const statusNode=drawer.querySelector('[data-vf-gift-status]');
      const bar=drawer.querySelector('[data-vf-gift-bar]');
      const label=drawer.dataset.vfGiftLabel||'';
      if(bar)bar.style.width=percent+'%';
      if(statusNode){
        let template=drawer.dataset.vfGiftRemaining||'';
        if(remaining<=0){
          if(drawer.dataset.vfGiftInCart==='true'&&drawer.dataset.vfGiftIsFree==='true')template=drawer.dataset.vfGiftUnlocked||'';
          else if(drawer.dataset.vfGiftInCart==='true')template=drawer.dataset.vfGiftPending||'';
          else template=drawer.dataset.vfGiftReached||'';
        }
        statusNode.textContent=(template||'').replace('[amount]',money(remaining)).replace('[gift]',label);
      }
    }
  };

  let giftSyncPending=false;
  const vfSavedKey='valuraa_saved_cart_v1';

  const readSaved=()=>{
    try{
      const value=JSON.parse(localStorage.getItem(vfSavedKey)||'[]');
      return Array.isArray(value)?value.slice(0,20):[];
    }catch(error){return []}
  };

  const writeSaved=(items)=>{
    try{localStorage.setItem(vfSavedKey,JSON.stringify(items.slice(0,20)))}catch(error){}
  };

  const savedSignature=(item)=>[
    item.variantId||0,
    item.sellingPlanId||0,
    JSON.stringify(item.properties||{})
  ].join('|');

  const renderSaved=(drawer=document.querySelector('[data-vf-drawer]'))=>{
    const wrap=drawer?.querySelector('[data-vf-saved-items]');
    const list=drawer?.querySelector('[data-vf-saved-list]');
    if(!wrap||!list)return;
    const saved=readSaved();
    list.replaceChildren();
    wrap.hidden=!saved.length;
    saved.forEach((item)=>{
      const row=document.createElement('article');
      row.className='vf-saved-item';

      if(item.image){
        const media=document.createElement(item.url?'a':'span');
        media.className='vf-saved-item__media';
        if(item.url)media.href=item.url;
        const img=document.createElement('img');
        img.src=item.image;
        img.alt='';
        img.loading='lazy';
        media.appendChild(img);
        row.appendChild(media);
      }

      const copy=document.createElement('div');
      copy.className='vf-saved-item__copy';
      const title=document.createElement(item.url?'a':'span');
      if(item.url)title.href=item.url;
      title.textContent=item.title||'Saved item';
      copy.appendChild(title);
      if(item.variantTitle){
        const variant=document.createElement('small');
        variant.textContent=item.variantTitle;
        copy.appendChild(variant);
      }
      row.appendChild(copy);

      const action=document.createElement('button');
      action.type='button';
      action.className='vf-saved-item__action';
      action.dataset.vfSavedAdd='true';
      action.dataset.savedSignature=savedSignature(item);
      action.textContent=drawer.dataset.vfMoveToBag||'Move to bag';
      row.appendChild(action);

      list.appendChild(row);
    });
  };

  const snapshotLine=(line)=>line?{
    variantId:Number(line.dataset.variantId)||0,
    sellingPlanId:Number(line.dataset.sellingPlanId)||0,
    properties:(()=>{try{return JSON.parse(line.dataset.properties||'{}')}catch(error){return {}}})(),
    quantity:Math.max(1,Number(line.querySelector('[data-vf-cart-qty-input]')?.value)||1),
    title:line.dataset.title||'',
    variantTitle:line.dataset.variantTitle||'',
    url:line.dataset.url||'',
    image:line.dataset.image||''
  }:null;

  const addSavedItem=(item)=>{
    if(!item?.variantId)return;
    const saved=readSaved();
    const signature=savedSignature(item);
    const existing=saved.find((entry)=>savedSignature(entry)===signature);
    if(existing)existing.quantity=Math.max(existing.quantity||1,item.quantity||1);
    else saved.unshift(item);
    writeSaved(saved);
  };

  const removeSavedItem=(signature)=>{
    const next=readSaved().filter((item)=>savedSignature(item)!==signature);
    writeSaved(next);
  };

  let lastRemovedItem=null;
  let undoTimer=0;

  const showUndo=(drawer,item)=>{
    const toast=drawer?.querySelector('[data-vf-cart-undo]');
    if(!toast||!item)return;
    lastRemovedItem=item;
    const message=toast.querySelector('[data-vf-cart-undo-message]');
    const template=drawer.dataset.vfRemovedTemplate||'[product] removed from your bag.';
    if(message)message.textContent=template.replace('[product]',item.title||'Item');
    toast.hidden=false;
    toast.classList.remove('is-visible');
    requestAnimationFrame(()=>toast.classList.add('is-visible'));
    clearTimeout(undoTimer);
    undoTimer=window.setTimeout(()=>{
      toast.classList.remove('is-visible');
      window.setTimeout(()=>{if(toast.isConnected)toast.hidden=true},220);
      if(lastRemovedItem===item)lastRemovedItem=null;
    },3800);
  };

  const syncThresholdGift=(drawer)=>{
    if(!drawer||giftSyncPending||drawer.dataset.vfAutoGift!=='true')return;
    const variantId=Number(drawer.dataset.vfGiftVariantId)||0;
    const threshold=Math.max(0,Number(drawer.dataset.vfGiftThreshold)||0);
    const rate=Math.max(.000001,Number(window.Shopify?.currency?.rate)||1);
    const qualifyingTotal=Math.max(0,Number(drawer.dataset.vfQualifyingTotal)||0);
    const qualifies=variantId>0&&threshold>0&&qualifyingTotal>=Math.round(threshold*100*rate);
    const inCart=drawer.dataset.vfGiftInCart==='true';
    const lineKey=drawer.dataset.vfGiftLineKey||'';
    if(qualifies===inCart)return;

    giftSyncPending=true;
    enqueue(async()=>{
      try{
        let response=null;
        if(qualifies){
          const formData=new FormData();
          formData.set('id',String(variantId));
          formData.set('quantity','1');
          formData.set('properties[_valuraa_gift]','threshold');
          formData.set('sections',cartSection);
          formData.set('sections_url',window.location.pathname);
          response=await fetch(root+'cart/add.js',{
            method:'POST',
            headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
            body:formData
          });
        }else if(lineKey){
          response=await fetch(root+'cart/change.js',{
            method:'POST',
            headers:{Accept:'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
            body:JSON.stringify({id:lineKey,quantity:0,sections:[cartSection],sections_url:window.location.pathname})
          });
        }
        if(!response)return;
        const data=await response.json();
        if(!response.ok||data.status)throw new Error();
        const html=getSectionHtml(data);
        if(html)replaceDrawer(html,true);
      }catch(error){
        // Optional gift sync must never block the buying path.
      }finally{
        giftSyncPending=false;
      }
    });
  };

  const loadRecommendations=async(drawer)=>{
    const slot=drawer?.querySelector('[data-vf-cart-recs]');
    if(!slot||slot.dataset.loaded==='true'||!slot.dataset.url)return;
    slot.dataset.loaded='true';
    try{
      const response=await fetch(slot.dataset.url,{headers:{Accept:'text/html'}});
      if(!response.ok)throw new Error();
      const html=await response.text();
      const parsed=new DOMParser().parseFromString(html,'text/html');
      const rendered=parsed.querySelector('[data-vf-cart-recommendations-rendered]');
      if(rendered&&rendered.innerHTML.trim())slot.innerHTML=rendered.innerHTML;
      else slot.remove();
    }catch(error){slot.remove()}
  };

  const afterDrawerPaint=(drawer)=>{
    requestAnimationFrame(()=>{
      if(!drawer?.isConnected||!drawer.open)return;
      renderSaved(drawer);
      const deferred=()=>{
        if(!drawer?.isConnected||!drawer.open)return;
        loadRecommendations(drawer);
        syncThresholdGift(drawer);
      };
      if(reduce)deferred();
      else if('requestIdleCallback'in window)requestIdleCallback(deferred,{timeout:520});
      else window.setTimeout(deferred,240);
    });
  };

  const closeDrawer=(drawer)=>{
    if(!drawer?.open){setDrawerOpenState(false);return}
    if(reduce){
      drawer.close();
      drawer.classList.remove('is-closing');
      setDrawerOpenState(false);
      restoreDrawerFocus();
      return;
    }
    if(drawer.classList.contains('is-closing'))return;

    drawer.classList.add('is-closing');

    let done=false;
    const finish=()=>{
      if(done)return;
      done=true;
      drawer.removeEventListener('transitionend',onEnd);
      if(drawer.open)drawer.close();
      drawer.classList.remove('is-closing');
      setDrawerOpenState(false);
      restoreDrawerFocus();
    };
    const onEnd=(event)=>{
      if(event.target===drawer&&event.propertyName==='transform')finish();
    };

    drawer.addEventListener('transitionend',onEnd);
    window.setTimeout(finish,300);
  };

  const openDrawer=(drawer,focusSelector='')=>{
    if(!drawer||typeof drawer.showModal!=='function')return;
    if(!drawer.open)captureDrawerReturnFocus(drawer);
    drawer.classList.remove('is-closing');
    drawer.classList.add('is-opening');
    if(!drawer.open)drawer.showModal();
    setDrawerOpenState(true);
    drawer.dataset.vfOpenedOnce='true';
    window.setTimeout(()=>drawer.classList.remove('is-opening'),420);
    syncShippingProgress(drawer);
    afterDrawerPaint(drawer);
    requestAnimationFrame(()=>{
      const target=focusSelector?drawer.querySelector(focusSelector):null;
      (target||drawer.querySelector('[data-vf-drawer-close]'))?.focus({preventScroll:true});
    });
  };

  const replaceDrawer=(html,open=true,focusSelector='')=>{
    const next=parseDrawer(html);
    const current=document.querySelector('[data-vf-drawer]');
    if(!next||!current)return current;
    const wasOpen=current.open;
    const count=Number(next.dataset.vfCartCount||0);
    current.replaceWith(next);
    updateCartCount(count);
    syncShippingProgress(next);
    if(open&&wasOpen&&typeof next.showModal==='function'){
      next.classList.add('is-refreshing');
      next.showModal();
      setDrawerOpenState(true);
      afterDrawerPaint(next);
      requestAnimationFrame(()=>{
        const target=focusSelector?next.querySelector(focusSelector):null;
        (target||next.querySelector('[data-vf-drawer-close]'))?.focus({preventScroll:true});
        requestAnimationFrame(()=>next.classList.remove('is-refreshing'));
      });
    }else if(open){
      openDrawer(next,focusSelector);
    }else{
      setDrawerOpenState(false);
      requestAnimationFrame(()=>syncThresholdGift(next));
    }
    return next;
  };

  const status=(message)=>{
    const node=document.querySelector('[data-vf-cart-status]');
    if(node)node.textContent=message||'';
  };

  const setProductError=(form,message)=>{
    const node=form?.closest('[data-vf-product]')?.querySelector('[data-vf-product-error]');
    if(!node)return;
    node.hidden=!message;
    node.textContent=message||'';
  };

  const getSectionHtml=(payload)=>payload?.sections?.[cartSection]||null;

  const setTriggerLabel=(trigger,text)=>{
    if(!trigger)return;
    const label=trigger.querySelector?.('[data-vf-trigger-label]');
    if(label)label.textContent=text||'';
    else trigger.textContent=text||'';
  };

  const fallbackDrawer=async(open=true)=>{
    const response=await fetch(root+'?sections='+encodeURIComponent(cartSection),{headers:{Accept:'application/json'}});
    if(!response.ok)throw new Error();
    const sections=await response.json();
    return replaceDrawer(sections[cartSection],open);
  };

  const addVariant=(variantId,quantity=1,trigger=null)=>{
    const id=Number(variantId);
    const qty=Math.max(1,Number(quantity)||1);
    if(!id)return Promise.reject(new Error('Invalid variant'));

    const original=trigger?.querySelector?.('[data-vf-trigger-label]')?.textContent||trigger?.textContent||'';
    if(trigger){
      trigger.disabled=true;
      trigger.setAttribute('aria-busy','true');
      setTriggerLabel(trigger,trigger.dataset.addingLabel||original);
    }

    optimisticCount(qty);
    const pendingDrawer=document.querySelector('[data-vf-drawer]');
    if(pendingDrawer?.open){
      pendingDrawer.classList.add('is-syncing');
      status(pendingDrawer.dataset.vfAddingLabel||'');
    }

    return enqueue(async()=>{
      try{
        const formData=new FormData();
        formData.set('id',String(id));
        formData.set('quantity',String(qty));
        formData.set('sections',cartSection);
        formData.set('sections_url',window.location.pathname);
        const response=await fetch(root+'cart/add.js',{
          method:'POST',
          headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
          body:formData
        });
        const data=await response.json();
        if(!response.ok||data.status)throw new Error(data.description||data.message||document.querySelector('[data-vf-drawer]')?.dataset.vfUpsellError||'');
        const html=getSectionHtml(data);
        if(html)replaceDrawer(html,true);else await fallbackDrawer(true);
        navigator.vibrate?.(4);
        if(trigger){
          trigger.classList.add('is-added');
          setTriggerLabel(trigger,trigger.dataset.addedLabel||original);
          window.setTimeout(()=>{if(trigger.isConnected){trigger.classList.remove('is-added');setTriggerLabel(trigger,original)}},900);
        }
        return data;
      }catch(error){
        document.querySelector('[data-vf-drawer]')?.classList.remove('is-syncing');
        updateCartCount(Math.max(0,cartCount()-qty));
        status(error.message||document.querySelector('[data-vf-drawer]')?.dataset.vfUpsellError||'');
        throw error;
      }finally{
        if(trigger){
          trigger.disabled=false;
          trigger.removeAttribute('aria-busy');
        }
      }
    });
  };

  window.ValuraaCart=Object.freeze({
    addVariant,
    open:()=>openDrawer(document.querySelector('[data-vf-drawer]'))
  });

  let motionObserver=null;
  const initMotion=(scope=document)=>{
    const nodes=[...scope.querySelectorAll('.vf-reveal,[data-vf-reveal],[data-vf-motion]')].filter((el)=>!el.classList.contains('is-visible'));
    if(reduce||!'IntersectionObserver'in window){
      nodes.forEach((el)=>el.classList.add('is-visible'));
      return;
    }
    if(!motionObserver){
      motionObserver=new IntersectionObserver((entries)=>entries.forEach((entry)=>{
        if(!entry.isIntersecting)return;
        const el=entry.target;
        el.classList.add('is-motion-ready');
        requestAnimationFrame(()=>el.classList.add('is-visible'));
        window.setTimeout(()=>el.classList.remove('is-motion-ready'),760);
        motionObserver.unobserve(el);
      }),{rootMargin:'0px 0px -7%',threshold:.08});
    }
    nodes.forEach((el,index)=>{
      el.style.setProperty('--vf-reveal-delay',Math.min(index%6,5)*45+'ms');
      motionObserver.observe(el);
    });
  };
  initMotion(); document.addEventListener('shopify:section:load',(event)=>initMotion(event.target));

  document.addEventListener('change',(event)=>{
    if(event.target.matches('[data-vf-country],[data-vf-language]'))event.target.closest('form')?.submit();
  });

  const drawerDragMq=matchMedia('(max-width:540px)');
  let drawerDrag=null;
  let drawerDragFrame=0;
  const paintDrawerDrag=()=>{
    drawerDragFrame=0;
    if(!drawerDrag)return;
    const dy=Math.max(0,drawerDrag.lastY-drawerDrag.startY);
    drawerDrag.drawer.style.setProperty('--vf-drawer-drag-y',Math.min(dy,260)+'px');
  };
  const moveDrawerDrag=(event)=>{
    if(!drawerDrag||event.pointerId!==drawerDrag.pointerId)return;
    drawerDrag.lastY=event.clientY;
    if(!drawerDragFrame)drawerDragFrame=requestAnimationFrame(paintDrawerDrag);
  };
  const removeDrawerDragListeners=()=>{
    document.removeEventListener('pointermove',moveDrawerDrag);
    document.removeEventListener('pointerup',endDrawerDrag);
    document.removeEventListener('pointercancel',cancelDrawerDrag);
  };
  const finishDrawerDrag=(event,cancelled=false)=>{
    if(!drawerDrag||event.pointerId!==drawerDrag.pointerId)return;
    const state=drawerDrag;
    drawerDrag=null;
    if(drawerDragFrame){cancelAnimationFrame(drawerDragFrame);drawerDragFrame=0}
    removeDrawerDragListeners();
    const dy=Math.max(0,state.lastY-state.startY);
    const elapsed=Math.max(1,performance.now()-state.startTime);
    const velocity=dy/elapsed;
    state.drawer.classList.remove('is-dragging');
    state.drawer.style.removeProperty('--vf-drawer-drag-y');
    if(!cancelled&&(dy>96||velocity>.72)){
      closeDrawer(state.drawer);
      navigator.vibrate?.(4);
    }
  };
  function endDrawerDrag(event){finishDrawerDrag(event,false)}
  function cancelDrawerDrag(event){finishDrawerDrag(event,true)}
  document.addEventListener('pointerdown',(event)=>{
    if(!drawerDragMq.matches)return;
    if(event.pointerType==='mouse'&&event.button!==0)return;
    const head=event.target.closest?.('.vf-drawer__head');
    const drawer=head?.closest?.('[data-vf-drawer]');
    if(!head||!drawer?.open||event.target.closest('button,a,input,select,textarea'))return;
    drawerDrag={drawer,pointerId:event.pointerId,startY:event.clientY,lastY:event.clientY,startTime:performance.now()};
    head.setPointerCapture?.(event.pointerId);
    drawer.classList.add('is-dragging');
    drawer.style.setProperty('--vf-drawer-drag-y','0px');
    document.addEventListener('pointermove',moveDrawerDrag,{passive:true});
    document.addEventListener('pointerup',endDrawerDrag,{passive:true});
    document.addEventListener('pointercancel',cancelDrawerDrag,{passive:true});
  },{passive:true});

  document.addEventListener('click',(event)=>{
    const close=event.target.closest('[data-vf-drawer-close]');
    if(close){closeDrawer(document.querySelector('[data-vf-drawer]'));return}

    const drawer=event.target.closest('[data-vf-drawer]');
    if(drawer&&event.target===drawer){closeDrawer(drawer);return}

    const bag=event.target.closest('.vf-cart-link');
    if(bag){
      const current=document.querySelector('[data-vf-drawer]');
      if(current&&typeof current.showModal==='function'){
        event.preventDefault();
        openDrawer(current);
      }
      return;
    }

    const undo=event.target.closest('[data-vf-cart-undo-action]');
    if(undo){
      event.preventDefault();
      const item=lastRemovedItem;
      if(!item||undo.disabled)return;
      undo.disabled=true;
      undo.setAttribute('aria-busy','true');
      enqueue(async()=>{
        try{
          const payload={id:item.variantId,quantity:item.quantity};
          if(item.properties&&Object.keys(item.properties).length)payload.properties=item.properties;
          if(item.sellingPlanId)payload.selling_plan=item.sellingPlanId;
          const response=await fetch(root+'cart/add.js',{
            method:'POST',
            headers:{Accept:'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
            body:JSON.stringify({items:[payload],sections:[cartSection],sections_url:window.location.pathname})
          });
          const data=await response.json();
          if(!response.ok||data.status)throw new Error(data.description||data.message||'');
          const html=getSectionHtml(data);
          const next=html?replaceDrawer(html,true):await fallbackDrawer(true);
          if(Number.isFinite(data.item_count))updateCartCount(data.item_count);
          lastRemovedItem=null;
          clearTimeout(undoTimer);
          next?.querySelector('[data-vf-cart-undo]')?.setAttribute('hidden','');
          status('');
        }catch(error){
          const drawer=document.querySelector('[data-vf-drawer]');
          status(error.message||drawer?.dataset.vfUndoError||'');
          const current=drawer?.querySelector('[data-vf-cart-undo-action]');
          if(current){current.disabled=false;current.removeAttribute('aria-busy')}
        }
      });
      return;
    }

    const saveNote=event.target.closest('[data-vf-cart-note-save]');
    if(saveNote){
      event.preventDefault();
      const drawer=saveNote.closest('[data-vf-drawer]');
      const note=drawer?.querySelector('[data-vf-cart-note]');
      const noteStatus=drawer?.querySelector('[data-vf-note-status]');
      if(!drawer||!note||saveNote.disabled)return;
      saveNote.disabled=true;
      saveNote.setAttribute('aria-busy','true');
      if(noteStatus)noteStatus.textContent='';
      enqueue(async()=>{
        try{
          const response=await fetch(root+'cart/update.js',{
            method:'POST',
            headers:{Accept:'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
            body:JSON.stringify({note:note.value})
          });
          const data=await response.json();
          if(!response.ok||data.status)throw new Error(data.description||data.message||'');
          if(noteStatus)noteStatus.textContent=drawer.dataset.vfNoteSaved||'';
          saveNote.classList.add('is-saved');
          window.setTimeout(()=>saveNote?.classList.remove('is-saved'),900);
        }catch(error){
          if(noteStatus)noteStatus.textContent=error.message||drawer.dataset.vfNoteError||'';
        }finally{
          saveNote.disabled=false;
          saveNote.removeAttribute('aria-busy');
        }
      });
      return;
    }

    const saveForLater=event.target.closest('[data-vf-save-for-later]');
    if(saveForLater){
      event.preventDefault();
      const line=saveForLater.closest('[data-vf-cart-line]');
      const item=snapshotLine(line);
      const remove=line?.querySelector('[data-vf-remove]');
      if(item?.variantId&&remove){
        addSavedItem(item);
        line.dataset.vfSaveLater='true';
        renderSaved(saveForLater.closest('[data-vf-drawer]'));
        remove.click();
      }
      return;
    }

    const savedAdd=event.target.closest('[data-vf-saved-add]');
    if(savedAdd&&!savedAdd.disabled){
      event.preventDefault();
      const signature=savedAdd.dataset.savedSignature||'';
      const item=readSaved().find((entry)=>savedSignature(entry)===signature);
      if(!item?.variantId)return;
      savedAdd.disabled=true;
      savedAdd.setAttribute('aria-busy','true');
      const original=savedAdd.textContent;
      savedAdd.textContent=savedAdd.closest('[data-vf-drawer]')?.dataset.vfAddingLabel||original;
      enqueue(async()=>{
        try{
          const payload={id:item.variantId,quantity:Math.max(1,item.quantity||1)};
          if(item.properties&&Object.keys(item.properties).length)payload.properties=item.properties;
          if(item.sellingPlanId)payload.selling_plan=item.sellingPlanId;
          const response=await fetch(root+'cart/add.js',{
            method:'POST',
            headers:{Accept:'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
            body:JSON.stringify({items:[payload],sections:[cartSection],sections_url:window.location.pathname})
          });
          const data=await response.json();
          if(!response.ok||data.status)throw new Error(data.description||data.message||'');
          removeSavedItem(signature);
          const html=getSectionHtml(data);
          const next=html?replaceDrawer(html,true):await fallbackDrawer(true);
          renderSaved(next||document.querySelector('[data-vf-drawer]'));
          if(Number.isFinite(data.item_count))updateCartCount(data.item_count);
          navigator.vibrate?.([12,20,12]);
        }catch(error){
          status(error.message||document.querySelector('[data-vf-drawer]')?.dataset.vfUpsellError||'');
          if(savedAdd.isConnected){
            savedAdd.disabled=false;
            savedAdd.removeAttribute('aria-busy');
            savedAdd.textContent=original;
          }
        }
      });
      return;
    }

    const upsell=event.target.closest('[data-vf-upsell-add]');
    if(upsell&&!upsell.disabled){
      const variantId=Number(upsell.dataset.variantId);
      if(!variantId)return;
      event.preventDefault();
      addVariant(variantId,1,upsell).catch(()=>{});
      return;
    }

    const change=event.target.closest('[data-vf-cart-change]');
    if(!change||change.disabled)return;
    event.preventDefault();

    const key=change.dataset.key;
    const quantity=Math.max(0,Number(change.dataset.quantity)||0);
    const line=change.closest('[data-vf-cart-line]');
    const quantityNode=line?.querySelector('[data-vf-cart-qty-input],.vf-drawer-item__qty span');
    const oldQuantity=Math.max(0,Number(quantityNode?.dataset?.currentQuantity??quantityNode?.value??quantityNode?.textContent)||0);
    const action=change.dataset.vfQtyAction||'';
    if(!key||quantity===oldQuantity)return;

    const removedSnapshot=quantity===0&&line?snapshotLine(line):null;
    if(removedSnapshot)removedSnapshot.quantity=oldQuantity;
    const savedForLater=line?.dataset.vfSaveLater==='true';

    const delta=quantity-oldQuantity;
    updateCartCount(Math.max(0,cartCount()+delta));

    if(quantityNode){
      if('value'in quantityNode)quantityNode.value=String(quantity);
      else quantityNode.textContent=String(quantity);
      if(quantityNode.dataset)quantityNode.dataset.currentQuantity=String(quantity);
    }
    const decrease=line?.querySelector('[data-vf-qty-action="decrease"]');
    const increase=line?.querySelector('[data-vf-qty-action="increase"]');
    if(decrease)decrease.dataset.quantity=String(Math.max(0,quantity-1));
    if(increase)increase.dataset.quantity=String(quantity+1);

    line?.classList.add('is-updating');
    line?.querySelectorAll('[data-vf-cart-change]').forEach((button)=>button.disabled=true);
    status(document.querySelector('[data-vf-drawer]')?.dataset.vfUpdatingLabel||'');

    const focusSelector=action
      ? '[data-vf-cart-line][data-key="'+CSS.escape(key)+'"] [data-vf-qty-action="'+action+'"]'
      : '';

    enqueue(async()=>{
      try{
        const response=await fetch(root+'cart/change.js',{
          method:'POST',
          headers:{Accept:'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({id:key,quantity,sections:[cartSection],sections_url:window.location.pathname})
        });
        const data=await response.json();
        if(!response.ok||data.status)throw new Error(data.description||data.message||document.querySelector('[data-vf-drawer]')?.dataset.vfUpdateError||'');
        const html=getSectionHtml(data);
        const nextDrawer=html?replaceDrawer(html,true,focusSelector):await fallbackDrawer(true);
        if(Number.isFinite(data.item_count))updateCartCount(data.item_count);
        if(removedSnapshot?.variantId&&!savedForLater)showUndo(nextDrawer||document.querySelector('[data-vf-drawer]'),removedSnapshot);
        renderSaved(nextDrawer||document.querySelector('[data-vf-drawer]'));
        status('');
      }catch(error){
        status(error.message||document.querySelector('[data-vf-drawer]')?.dataset.vfUpdateError||'');
        await fallbackDrawer(true).catch(()=>{});
      }
    });
  });

  document.addEventListener('change',(event)=>{
    const upsellSelect=event.target.closest?.('[data-vf-upsell-select]');
    if(upsellSelect){
      const card=upsellSelect.closest('.vf-cart-rec');
      const button=card?.querySelector('[data-vf-upsell-add]');
      if(button)button.dataset.variantId=upsellSelect.value;
      return;
    }

    const giftOrder=event.target.closest?.('[data-vf-gift-order]');
    if(giftOrder){
      const drawer=giftOrder.closest('[data-vf-drawer]');
      const giftStatus=drawer?.querySelector('[data-vf-gift-status]');
      const desired=giftOrder.checked;
      giftOrder.disabled=true;
      if(giftStatus)giftStatus.textContent='';
      enqueue(async()=>{
        try{
          const response=await fetch(root+'cart/update.js',{
            method:'POST',
            headers:{Accept:'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
            body:JSON.stringify({attributes:{'Gift order':desired?'Yes':''}})
          });
          const data=await response.json();
          if(!response.ok||data.status)throw new Error(data.description||data.message||'');
          if(giftStatus)giftStatus.textContent=drawer?.dataset.vfGiftSaved||'';
        }catch(error){
          giftOrder.checked=!desired;
          if(giftStatus)giftStatus.textContent=error.message||drawer?.dataset.vfNoteError||'';
        }finally{
          giftOrder.disabled=false;
        }
      });
      return;
    }

    const input=event.target.closest?.('[data-vf-cart-qty-input]');
    if(!input)return;
    const line=input.closest('[data-vf-cart-line]');
    const oldQuantity=Math.max(0,Number(input.dataset.currentQuantity)||0);
    const max=Number(input.max)||999;
    const quantity=Math.max(0,Math.min(max,Number.parseInt(input.value,10)||0));
    input.value=String(quantity);
    if(!line||quantity===oldQuantity)return;
    const selector=quantity>oldQuantity?'[data-vf-qty-action="increase"]':'[data-vf-qty-action="decrease"]';
    const proxy=line.querySelector(selector);
    if(!proxy)return;
    proxy.dataset.quantity=String(quantity);
    proxy.click();
  });

  document.addEventListener('keydown',(event)=>{
    const input=event.target.closest?.('[data-vf-cart-qty-input]');
    if(!input||event.key!=='Enter')return;
    event.preventDefault();
    input.blur();
  });

  document.addEventListener('cancel',(event)=>{
    const drawer=event.target?.matches?.('[data-vf-drawer]')?event.target:null;
    if(!drawer)return;
    event.preventDefault();
    closeDrawer(drawer);
  },true);

  document.addEventListener('submit',(event)=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement))return;
    if(form.matches('.vf-drawer__checkout-form')){
      const button=form.querySelector('[data-vf-checkout]');
      if(button&&!button.hasAttribute('aria-busy')){
        const label=button.querySelector('span');
        button.setAttribute('aria-busy','true');
        button.classList.add('is-loading');
        if(label&&button.dataset.checkoutLoading)label.textContent=button.dataset.checkoutLoading;
      }
      return;
    }
    if(!form.matches('.vfp-form'))return;
    if(!event.submitter?.matches('[data-vf-add]'))return;
    event.preventDefault();
    if(form.dataset.vfSubmitting==='true')return;

    const button=event.submitter;
    const productRoot=form.closest('[data-vf-product]');
    const stickyButton=productRoot?.querySelector('[data-vf-sticky-add]');
    const original=button.querySelector('[data-vf-trigger-label]')?.textContent||button.textContent;
    const stickyOriginal=stickyButton?.querySelector('[data-vf-trigger-label]')?.textContent||productRoot?.dataset.vfAddLabel||original;
    const addingLabel=productRoot?.dataset.vfAddingLabel||original;
    const addedLabel=productRoot?.dataset.vfAddedLabel||original;
    const formData=new FormData(form);
    const quantity=Math.max(1,Number(formData.get('quantity'))||1);
    formData.set('sections',cartSection);
    formData.set('sections_url',window.location.pathname);
    form.dataset.vfSubmitting='true';
    button.disabled=true;
    button.setAttribute('aria-busy','true');
    setTriggerLabel(button,addingLabel);
    if(stickyButton){
      stickyButton.disabled=true;
      stickyButton.setAttribute('aria-busy','true');
      setTriggerLabel(stickyButton,addingLabel);
    }
    setProductError(form,'');

    optimisticCount(quantity);
    const pendingDrawer=document.querySelector('[data-vf-drawer]');
    if(pendingDrawer?.open){pendingDrawer.classList.add('is-syncing');status(pendingDrawer.dataset.vfAddingLabel||'');}

    enqueue(async()=>{
      try{
        const response=await fetch(root+'cart/add.js',{
          method:'POST',
          headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
          body:formData
        });
        const data=await response.json();
        if(!response.ok||data.status)throw new Error(data.description||data.message||productRoot?.dataset.vfAddError||'');
        const html=getSectionHtml(data);
        if(html)replaceDrawer(html,true);else await fallbackDrawer(true);
        navigator.vibrate?.(4);
        button.classList.add('is-added');
        stickyButton?.classList.add('is-added');
        setTriggerLabel(button,addedLabel);
        setTriggerLabel(stickyButton,addedLabel);
        window.setTimeout(()=>{
          if(button.isConnected){button.classList.remove('is-added');setTriggerLabel(button,original)}
          if(stickyButton?.isConnected){stickyButton.classList.remove('is-added');setTriggerLabel(stickyButton,stickyOriginal)}
        },900);
      }catch(error){
        document.querySelector('[data-vf-drawer]')?.classList.remove('is-syncing');
        updateCartCount(Math.max(0,cartCount()-quantity));
        setProductError(form,error.message||productRoot?.dataset.vfAddError||'');
        setTriggerLabel(button,original);
        setTriggerLabel(stickyButton,stickyOriginal);
      }finally{
        form.dataset.vfSubmitting='false';
        button.removeAttribute('aria-busy');
        button.disabled=false;
        if(stickyButton){stickyButton.disabled=false;stickyButton.removeAttribute('aria-busy')}
      }
    });
  });

  const hydrateInitialDrawer=()=>{
    const drawer=document.querySelector('[data-vf-drawer]');
    if(!drawer)return;
    setDrawerOpenState(Boolean(drawer.open));
    if(drawer.dataset.vfOpenedOnce==='true')return;
    syncShippingProgress(drawer);
    renderSaved(drawer);
  };
  if('requestIdleCallback'in window)requestIdleCallback(hydrateInitialDrawer,{timeout:1600});
  else window.setTimeout(hydrateInitialDrawer,550);
})();
;
(()=>{if(window.__ValuraaAppShellV2)return;window.__ValuraaAppShellV2=true;
const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
const mobile=matchMedia('(max-width:899px)');
let lastY=scrollY,direction=0,travel=0,ticking=false,pressed=null;
const clearPressed=()=>{pressed?.classList.remove('vl-app-pressed');pressed=null};
const sync=()=>{
  const y=Math.max(0,scrollY),delta=y-lastY;
  if(document.body.classList.contains('vf-drawer-open')||document.documentElement.classList.contains('vfh2-locked')||document.documentElement.classList.contains('vfh2-search-locked')||document.body.classList.contains('vl-keyboard-open')){
    document.body.classList.remove('vl-app-scroll-down');direction=0;travel=0;
  }else if(y<110){
    document.body.classList.remove('vl-app-scroll-down');direction=0;travel=0;
  }else if(Math.abs(delta)>1){
    const next=delta>0?1:-1;
    if(next!==direction){direction=next;travel=0}
    travel+=Math.abs(delta);
    if(travel>=28){
      document.body.classList.toggle('vl-app-scroll-down',direction>0&&y>140);
      travel=0;
    }
  }
  lastY=y;ticking=false;
};
const onScroll=()=>{if(!ticking){ticking=true;requestAnimationFrame(sync)}};
let scrollBound=false;
const syncScrollBinding=()=>{
  if(mobile.matches&&!scrollBound){
    addEventListener('scroll',onScroll,{passive:true});
    scrollBound=true;
    lastY=scrollY;
  }else if(!mobile.matches&&scrollBound){
    removeEventListener('scroll',onScroll);
    scrollBound=false;
    ticking=false;
    direction=0;
    travel=0;
    document.body.classList.remove('vl-app-scroll-down');
  }
};
syncScrollBinding();
mobile.addEventListener?.('change',syncScrollBinding);
document.addEventListener('pointerdown',e=>{
  const el=e.target.closest('.vfdock__item,.vfh2__menu-button,.vfh2__search-trigger,.vfh2__bag,.vhx__cta,.vf-btn,.vfp-sticky__add,.vfp-sticky__buy,.vhome-card__add,.vugc-product__action,.vfc-quick button,.vf-drawer__checkout,.vf-cart-rec__action');
  if(!el||reduced)return;
  clearPressed();pressed=el;el.classList.add('vl-app-pressed');
  if(e.pointerType!=='mouse')navigator.vibrate?.(3);
},{passive:true});
addEventListener('pointerup',clearPressed,{passive:true});
addEventListener('pointercancel',clearPressed,{passive:true});
addEventListener('blur',clearPressed);
document.addEventListener('visibilitychange',()=>{if(document.hidden){document.body.classList.remove('vl-app-scroll-down');clearPressed()}});
})();
;(()=>{if(window.__ValuraaAppShellV3)return;window.__ValuraaAppShellV3=true;
const mq=matchMedia('(max-width:899px)');
const editable='input,textarea,select,[contenteditable="true"]';
const syncKeyboard=()=>{
  if(!mq.matches){
    document.body.classList.remove('vl-keyboard-open');
    return;
  }
  const vv=window.visualViewport;
  const viewportReduced=vv?window.innerHeight-vv.height>140:false;
  const focused=!!document.activeElement?.matches?.(editable);
  document.body.classList.toggle('vl-keyboard-open',viewportReduced&&focused);
};
const syncDock=()=>{
  const dock=document.querySelector('[data-vfdock]');
  if(!dock)return;
  const path=location.pathname;
  dock.querySelectorAll('[aria-current="page"]').forEach(el=>el.removeAttribute('aria-current'));
  let active=null;
  if(path==='/')active=dock.querySelector('[data-vfdock-home]');
  else if(path.startsWith('/collections')||path.startsWith('/products/'))active=dock.querySelector('[data-vfdock-collections]');
  else if(path.startsWith('/cart'))active=dock.querySelector('[data-vfdock-cart]');
  else if(path.startsWith('/search'))active=dock.querySelector('[data-vfdock-search]');
  active?.setAttribute('aria-current','page');
};
visualViewport?.addEventListener('resize',syncKeyboard,{passive:true});
visualViewport?.addEventListener('scroll',syncKeyboard,{passive:true});
document.addEventListener('focusin',syncKeyboard);
document.addEventListener('focusout',()=>setTimeout(syncKeyboard,0));
addEventListener('orientationchange',()=>setTimeout(syncKeyboard,120),{passive:true});
addEventListener('pageshow',()=>{syncKeyboard();syncDock()});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{syncKeyboard();syncDock()},{once:true});
else{syncKeyboard();syncDock()}
})();
;
(()=>{const body=document.body;if(!body)return;
const conn=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
const constrained=!!(conn&&(conn.saveData||/2g/.test(conn.effectiveType||'')));
const fine=matchMedia('(hover:hover) and (pointer:fine)');
const prefetched=new Set();
const productHref=a=>{
  if(!a||constrained)return null;
  let u;
  try{u=new URL(a.href,location.href)}catch(e){return null}
  if(u.origin!==location.origin||u.pathname===location.pathname||!u.pathname.startsWith('/products/'))return null;
  u.hash='';
  return u.href;
};
const prefetchHref=href=>{
  if(!href||prefetched.has(href)||prefetched.size>=6)return;
  prefetched.add(href);
  const link=document.createElement('link');
  link.rel='prefetch';
  link.href=href;
  link.fetchPriority='low';
  document.head.appendChild(link);
};
if(fine.matches&&!constrained){
  let hoverTimer=0;
  document.addEventListener('pointerover',event=>{
    const a=event.target.closest?.('a[href]');
    if(!a||a.contains(event.relatedTarget))return;
    const href=productHref(a);
    if(!href)return;
    clearTimeout(hoverTimer);
    hoverTimer=setTimeout(()=>prefetchHref(href),110);
  },{passive:true});
  document.addEventListener('pointerout',event=>{
    const a=event.target.closest?.('a[href]');
    if(a&&!a.contains(event.relatedTarget))clearTimeout(hoverTimer);
  },{passive:true});
}else if(!constrained&&'IntersectionObserver'in window){
  const warmVisible=()=>{
    const links=[...document.querySelectorAll('a[href]')].filter(a=>productHref(a)).slice(0,24);
    if(!links.length)return;
    let warmed=0;
    const observer=new IntersectionObserver(entries=>{
      for(const entry of entries){
        if(!entry.isIntersecting)continue;
        observer.unobserve(entry.target);
        const href=productHref(entry.target);
        if(href){prefetchHref(href);warmed++}
        if(warmed>=2){observer.disconnect();break}
      }
    },{rootMargin:'220px 0px',threshold:.01});
    links.forEach(a=>observer.observe(a));
  };
  if('requestIdleCallback'in window)requestIdleCallback(warmVisible,{timeout:1800});
  else setTimeout(warmVisible,700);
}

const key='valuraa_recent_searches_v1';
const read=()=>{try{const v=JSON.parse(localStorage.getItem(key)||'[]');return Array.isArray(v)?v.slice(0,5):[]}catch(e){return[]}};
const save=q=>{q=(q||'').trim();if(q.length<2)return;const next=[q,...read().filter(x=>x.toLowerCase()!==q.toLowerCase())].slice(0,5);try{localStorage.setItem(key,JSON.stringify(next))}catch(e){}};
const dialog=document.querySelector('[data-vfh3-search]');
const input=dialog?.querySelector('[data-vfh3-search-input]');
const form=dialog?.querySelector('.vfh2-search__form');
const popular=dialog?.querySelector('[data-vfh3-popular]');
const fire=q=>{if(!input)return;input.value=q;input.focus({preventScroll:true});input.dispatchEvent(new Event('input',{bubbles:true}))};
const renderRecent=()=>{
  if(!dialog||!form)return;
  dialog.querySelector('.vl-perf-recent')?.remove();
  const values=read();
  if(!values.length)return;
  const wrap=document.createElement('div');
  wrap.className='vl-perf-recent';
  const label=document.createElement('p');
  label.className='vl-perf-recent__label';
  label.textContent=body.dataset.vlRecentLabel||'Recent searches';
  const chips=document.createElement('div');
  chips.className='vl-perf-recent__chips';
  const fragment=document.createDocumentFragment();
  values.forEach(q=>{const b=document.createElement('button');b.type='button';b.textContent=q;b.addEventListener('click',()=>fire(q));fragment.appendChild(b)});
  chips.appendChild(fragment);
  wrap.append(label,chips);
  form.after(wrap);
};
form?.addEventListener('submit',()=>save(input?.value));
dialog?.addEventListener('click',event=>{const result=event.target.closest?.('.vfps-results__item,.vfps-results__all');if(result)save(input?.value)});
popular?.addEventListener('click',event=>{const a=event.target.closest('a');if(!a||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();const q=(a.textContent||'').trim();if(q){fire(q);save(q);renderRecent()}});
document.querySelectorAll('[data-vfh3-search-open]').forEach(button=>button.addEventListener('click',()=>requestAnimationFrame(renderRecent)));
})();

;(()=>{if(window.__ValuraaHeaderRuntimeV54)return;window.__ValuraaHeaderRuntimeV54=true;
const root=document.documentElement;
const body=document.body;
const menu=document.querySelector('[data-vfh3-menu]');
const search=document.querySelector('[data-vfh3-search]');
const clearAutoHide=()=>body?.classList.remove('vl-app-scroll-down');
const syncOverlay=()=>{
  const menuOpen=Boolean(menu?.open);
  const searchOpen=Boolean(search?.open);
  if(menuOpen||searchOpen)clearAutoHide();
  root.classList.toggle('vfh2-locked',menuOpen);
  root.classList.toggle('vfh2-search-locked',searchOpen);
};
document.addEventListener('pointerdown',event=>{
  if(event.target.closest?.('.vfh2__menu-button,[data-vfh3-search-open],[data-vfdock-search],.vfh2__bag'))clearAutoHide();
},{capture:true,passive:true});
document.addEventListener('click',event=>{
  const trigger=event.target.closest?.('[data-vfh3-search-open]');
  if(trigger&&menu?.open){
    menu.removeAttribute('open');
    root.classList.remove('vfh2-locked');
    clearAutoHide();
  }
},true);
menu?.addEventListener('toggle',syncOverlay);
if(search){
  const observer=new MutationObserver(syncOverlay);
  observer.observe(search,{attributes:true,attributeFilter:['open']});
  search.addEventListener('close',syncOverlay);
  search.addEventListener('cancel',()=>requestAnimationFrame(syncOverlay));
}
addEventListener('pageshow',syncOverlay);
syncOverlay();
})();

